export class HrPayWtMannerValueKey {
    private static readonly keyPrefix = 'hrPayWtMannerValue';
    public static pageHeader = `${HrPayWtMannerValueKey.keyPrefix}.pageHeader`;
    public static title = `${HrPayWtMannerValueKey.keyPrefix}.pageHeader`;
}
